import DynamicProductCarousel from '@src/components/DynamicProductCarousel'
import { ProductCardType } from '@utils/searchUtils'
import React from 'react'
import { useQuickOrderRecommendedProductsQuery } from '@src/queries/RecommendedProductsQuickOrderQuery.generated'
import { makeStyles } from '@material-ui/core/styles'
import { ErpType } from '@utils/useProductErpType'
import { useCurrentUser } from '@utils/useCurrentUser'

const useStyles = makeStyles((theme) => ({
  recommendedProductsContainer: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    paddingTop: theme.spacing(2),
  },
}))
const QuickOrderRecommendedProducts = ({
  participantId,
}: {
  participantId: string
}) => {
  const classes = useStyles()
  const { isBlueB2BUser } = useCurrentUser()
  const { data } = useQuickOrderRecommendedProductsQuery({
    ssr: false,
    variables: {
      input: {
        participantId,
        ...(isBlueB2BUser ? { erpType: ErpType.Blue } : {}),
      },
    },
  })

  return data?.getQuickOrderRecommendedProducts?.products.length ? (
    <div className={classes.recommendedProductsContainer}>
      <DynamicProductCarousel
        type={ProductCardType.Recommended}
        products={data?.getQuickOrderRecommendedProducts?.products}
        parentPageName="quick order"
        parentPageNameDetail="quick order page"
      />
    </div>
  ) : null
}

export default QuickOrderRecommendedProducts
